import { useQuery } from '@tanstack/react-query';
import { accounts } from '@/api/documents';
import SearchSelect from '@/components/SearchSelect';

interface Props {
  value: string;
  onChange: (id: string) => void;
  placeholder?: string;
  // alembic 0261: фільтр балансові/забалансові. undefined=всі; false=лише
  // балансові; true=лише забалансові (клас 0). Окремий queryKey, щоб кеш
  // балансових і забалансових не змішувався.
  offBalance?: boolean;
}

/**
 * Вибір рахунку з плану HOZRASCHETNY — комбобокс з пошуком (SearchSelect,
 * канон «поле великого переліку = поисковое», рішення власника 2026-09-01).
 * Пошук за кодом і назвою рахунку; порожній value = «—» (не обрано).
 */
export default function AccountSelect({ value, onChange, placeholder, offBalance }: Props) {
  const q = useQuery({
    queryKey: ['accounts', offBalance ?? 'all'],
    queryFn: () => accounts.list({ only_postable: true, off_balance: offBalance, limit: 600 }),
    staleTime: 60 * 60 * 1000,
  });

  return (
    <SearchSelect
      items={(q.data ?? []).map((a) => ({ id: a.id, label: `${a.code} — ${a.name}`, hint: null }))}
      value={value}
      onChange={onChange}
      placeholder={placeholder ?? '— почніть вводити код або назву —'}
    />
  );
}
